// extracted by mini-css-extract-plugin
var _1 = "Fm7wI";
var _2 = "_6zvGC";
var _3 = "hjQXd";
var _4 = "qIU2R";
var _5 = "pEeLF";
var _6 = "R09Zn";
var _7 = "k8ZIQ";
var _8 = "ZYZDu";
var _9 = "SswSq";
var _a = "cw_qx";
var _b = "ReacR";
export { _1 as "base", _2 as "empty", _3 as "icon", _4 as "icon-only", _5 as "loading", _6 as "name", _7 as "tag", _8 as "tags", _9 as "theme-dark", _a as "theme-light", _b as "toggle" }
